import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100px;
  padding: 0 20px 18px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background: #fff;

  a {
    color: #9d9fa2;
    font-weight: 700;
    text-decoration: none;
    font-size: 0.9em;
    text-transform: uppercase;
    &:hover {
      color: #f16621;
    }
  }

  ${({ small }) =>
    small &&
    css`
      height: 60px;
    `};
`;
